module.exports = __webpack_public_path__ + "img/DSC_0070.e3c828f5.jpg";